module.exports = "<page-header title=\"User Administration\" icon=\"fa fa-users\">\r\n\t<div style=\"display: flex\">\r\n\t\t<a ui-sref=\"admin.users\" class=\"btn btn-default\" id=\"option1\" ng-class=\"{ active: $state.current.name == 'admin.users'  }\">\r\n\t\t\t<i class=\"fa fa-users\"></i> Manage Users\r\n\t\t</a>\r\n\t\t<a ui-sref=\"admin.roles\" class=\"btn btn-default\" id=\"option3\" ng-class=\"{ active: $state.current.name == 'admin.roles'  }\">\r\n\t\t\t<i class=\"fa fa-th\"></i> Configure Roles\r\n\t\t</a>\r\n\t</div>\r\n</page-header>\r\n\r\n<div ui-view autoscroll=\"false\">\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/admin/admin.html
// module id = 149
// module chunks = 0